const PARAGRAPH_SEARCH_LIBRARY = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
     ... on SearchLibrary {
      filterTypes(text: "", category: [], type: [], pageNumber: 0) {
        alias
        author {
          name
          alias
        }
        body
        date
        image
        title
        total
        categories {
          alias
          color
          name
          weight
        }
        nid
      }
      id
      items
      type
      uuid
      categoriesFilter {
        name
        tid
      }
      contentTypesFilter {
        machineName
        name
      }
    }
  }
`;

export default PARAGRAPH_SEARCH_LIBRARY;
